const tabs = {
  loan: "loan",
  messages: "messages",
  cost: "cost",
  loanable: "loanable",
  calendar: "calendar",
};

const sections = {
  contacts: {
    target: "loan-section-contacts",
    tab: tabs.messages,
  },
  contribution: {
    target: "loan-section-cost",
    tab: tabs.cost,
  },
  messages: {
    target: "loan-section-messages",
    tab: tabs.messages,
  },
  loan: {
    target: "loan-section-loan",
    tab: tabs.loan,
  },
  dates: {
    target: "loan-section-dates",
    tab: tabs.loan,
  },
  info: {
    target: "loan-section-info",
    tab: tabs.loan,
  },
  incidents: {
    target: "loan-section-incidents",
    tab: tabs.loan,
  },
  autoValidation: {
    target: "loan-section-auto-validation",
    tab: tabs.loan,
  },
  cost: {
    target: "loan-section-cost",
    tab: tabs.cost,
  },
  instructions: {
    target: "loan-section-instructions",
    tab: tabs.loanable,
  },
  returnInstructions: {
    target: "loan-section-return-instructions",
    tab: tabs.loanable,
  },
  calendar: {
    target: "loan-section-calendar",
    tab: tabs.calendar,
  },
};

export { tabs, sections };
